var exports = {
  "x": "xa15a2ab7--58d804--button",
  "A": "xa15a2ab7--58d804--item",
};

module.exports = exports;
